/**
 * Application constants for NewsDesk
 * Contains playback modes, time formats, and utility functions
 *
 */

const playbackModes = [
  { value: 'normal', label: 'Normal' },
  { value: 'stop', label: 'Stop' },
  { value: 'holdLastFrame', label: 'Hold' },
  { value: 'loop', label: 'Loop' }
]

const getPlaybackModeLabel = (value) => {
  const mode = playbackModes.find((mode) => mode.value === value)
  return mode?.label
}

// Sentinel shown in UI to represent a stored password field (never sent back to the server as-is).
export const PASSWORD_SENTINEL = '••••••••'

// Connection types supported by the platform connection system.
// Mirrors PlatformConnection::CONNECTION_TYPES on the backend — update both when adding a new type.
export const CONNECTION_TYPES = [
  'content_delivery',
  'asset_delivery',
  'live_status',
  'live_editing',
  'playback_control',
  'video_preview',
  'routing_control',
  'graphics'
]

// Read from VITE_EDITOR_SCHEMA_VERSION in .env (base file, all environments).
// Increment when a new TipTap node/mark type is added to the schema.
// Must stay in sync with detectRequiredSchemaVersion() in StoryScriptController.php.
// Version history: 1=basic text  2=production notes  3=nd-* production elements
export const EDITOR_SCHEMA_VERSION = Number(import.meta.env.VITE_EDITOR_SCHEMA_VERSION)

export const constants = {
  playbackModes,
  getPlaybackModeLabel,
  timeFormats: ['h:mm a', 'h:mm A', 'HH:mm', 'H:mm', 'h:mma', 'h:mmA', 'HHmm']
}
